import type { IconData } from '@stacksjs/iconify-core'

export const contentAddFile: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h8l4 4v2.5A5.5 5.5 0 0 0 6.875 14H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.062 8.5a4 4 0 1 1-1.56 5.442l-.002-.004A4 4 0 0 1 8 12a4 4 0 0 1 .692-2.25a4 4 0 0 1 1.37-1.25M11.25 10v1.25H10v1.5h1.25V14h1.5v-1.25H14v-1.5h-1.25V10z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentAddFile
